// Generated with util/create-component.js
import React, { useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import ButtonGroup from '../ButtonGroup/ButtonGroup'
import Button from '../Button/Button'
import { BreadcrumbProps } from './Breadcrumb.types'
import { BreadCrumbContext } from './Breadcrumb.context'

const Breadcrumb: React.FC<BreadcrumbProps> = ({ crumbs }) => {
    const renderButtons = (buttons) => {
        if (!buttons || !Array.isArray(buttons)) {
            return null
        }

        return buttons.map((btn, i) => {
            return <Button key={i} className='r-breadcrumb-button' {...btn} size='sm' />
        })
    }

    const renderCrumbs = (crumbs) => {
        return crumbs.map((crumb, i) => {
            return (
                <div key={i} className='r-crumb-container'>
                    {crumb.link ? (
                        <Link className='r-crumb' to={crumb.link}>
                            {crumb.text}
                        </Link>
                    ) : (
                        <span className='r-crumb'>{crumb.text}</span>
                    )}
                </div>
            )
        })
    }

    return (
        <BreadCrumbContext.Consumer>
            {(context) => {
                return (
                    <div className='r-breadcrumb-bar' data-testid='Breadcrumb'>
                        <div className='r-crumbs'>{renderCrumbs(crumbs)}</div>
                        {/* <div className='r-breadcrumb-Search'> */}
                        {/*    <Autocomplete */}
                        {/*        noLabel */}
                        {/*        dataSource={{ */}
                        {/*            method: 'POST', */}
                        {/*            url: 'http://8eol9.mocklab.io/customerSearch', */}
                        {/*            body: (query) => { */}
                        {/*                return { */}
                        {/*                    searchQuery: query, */}
                        {/*                } */}
                        {/*            }, */}
                        {/*        }} */}
                        {/*        maxHeight={800} */}
                        {/*        name='BreadcrumbSearch' */}
                        {/*        placeholder='Search by Customer, Contact, LDC Account, Broker' */}
                        {/*        optionsTemplate={(data, onItemSelect) => { */}
                        {/*            if (data) { */}
                        {/*                return Object.keys(data).map((key) => { */}
                        {/*                    const dataItems = data[key] */}

                        {/*                    return ( */}
                        {/*                        <div style={{ padding: '15px' }}> */}
                        {/*                            <h4 style={{ fontSize: '12pt', padding: '10px 0' }}>{key}</h4> */}
                        {/*                            <div> */}
                        {/*                                {dataItems.map((d, i) => { */}
                        {/*                                    return autoCompleteSearchItem(d, i) */}
                        {/*                                })} */}
                        {/*                            </div> */}
                        {/*                        </div> */}
                        {/*                    ) */}
                        {/*                }) */}
                        {/*            } */}
                        {/*        }} */}
                        {/*    /> */}
                        {/* </div> */}
                        <div className='r-crumb-buttons'>{renderButtons(context.buttons)}</div>
                    </div>
                )
            }}
        </BreadCrumbContext.Consumer>
    )
}

export default Breadcrumb
